module.exports = __webpack_public_path__ + "img/tecnologia.e20b6670.svg";